module.exports = __webpack_public_path__ + "img/42.7e2faa4a.svg";